import React from "react";
import Helmet from "react-helmet";
import { Link } from "gatsby";

import Layout from "../components/layout";

export default () => {
	const ArticleSummaryBox = ({
		title,
		author,
		publishedDate,
		description,
		href,
	}) => {
		return (
			<section className="container maxWidth-800 mb-90">
				<a href={href}>
					<h2>{title}</h2>
				</a>
				<div className="text-xsmall verticalList mb-15">
					<div className="u-text-bold mr-5">{author}</div>
					<div className="text-light">{publishedDate}</div>
				</div>
				<div className="text-small mb-30">{description}...</div>
				<a
					className="button button-primary button-small text-small"
					href={href}>
					Read more →
				</a>
			</section>
		);
	};

	return (
		<Layout
			pageMeta={{
				title: "Articles",
			}}>
			<main>
				<header className="blog text-center mb-90">
					<div className="headerWithBg mb-50">
						<div className="container">
							<h1>Articles</h1>
							<p className="maxWidth-750 text-large text-dark itemCenter">
								Learn about SaaS emails, best practices for sending
								transactional emails, writing SaaS marketing emails, setting up
								email automations, creating email templates, working with email
								sending APIs & email providers, and more...
							</p>
						</div>
					</div>
				</header>

				<ArticleSummaryBox
					title="SendGrid Alternatives with Better Customer Support & Deliverability"
					author="Kristyna"
					publishedDate="published on August 2023"
					description="Tired of dealing with SendGrid's poor customer support? Struggling with the deliverability of your transactional emails? Read this detailed comparison between Sendgrid and other email providers"
					href="/articles/sendgrid-alternatives/"
				/>

				<ArticleSummaryBox
					title="Simple Amazon SES Alternatives for SaaS"
					author="Kristyna"
					publishedDate="published on August 2023"
					description="Amazon SES provides you with low-level tools for email delivery, but all the integration, email template setup, troubleshooting, analytics, etc. is up to you. Find a simpler Amazon SES alternative for your SaaS"
					href="/articles/amazon-ses-alternatives/"
				/>

				<ArticleSummaryBox
					title="The Best Mandrill Alternatives for Delivering & Managing SaaS Emails"
					author="Kristyna"
					publishedDate="published on August 2023"
					description="Mailchimp Transactional Emails, formerly Mandrill, is a paid Mailchimp add-on for sending transactional emails. If you're looking for a better alternative to Mandrill, check this detailed comparison for 2023"
					href="/articles/mandrill-alternatives/"
				/>

				<ArticleSummaryBox
					title="Mailgun Alternatives for SaaS with Better Customer Support & Reliability"
					author="Kristyna"
					publishedDate="published on August 2023"
					description="Looking for a better alternative to Mailgun? Need a complete solution for your SaaS? We’re bringing you a detailed comparison between Mailgun and other email providers for 2023"
					href="/articles/mailgun-alternatives/"
				/>

				<ArticleSummaryBox
					title="The Best Postmark Alternatives for Sending SaaS Emails"
					author="Kristyna"
					publishedDate="published on August 2023"
					description="Need to deliver not only transactional emails but also sent product updates and newsletters? And set up a welcome email sequence or prevent churns with email automation? Compare Postmark alternatives"
					href="/articles/postmark-alternatives/"
				/>

				<ArticleSummaryBox
					title="Dark mode in HTML email"
					author="Patrik"
					publishedDate="updated on March 2020"
					description="The new big trend in tech, dark mode, is coming to email. Learn how it works and how to make dark‑mode‑friendly HTML emails yourself"
					href="/articles/dark-mode-in-html-email/"
				/>

				<section className="blog">
					<div className="subscribeCta lightBlueBg">
						<div className="container maxWidth-800">
							<div className="fancyLabel">About Sidemail</div>

							<h2>Need to deliver emails? 💌</h2>
							<p>
								Sidemail is an all-in-one email platform for SaaS. We'll help
								you with delivering transactional emails via API, sending
								marketing emails, setting up automated email sequences, and
								managing contacts. Simple instructions. Quick setup.
							</p>
							<p>
								Create your account now and start sending your emails in under
								30 minutes.
							</p>

							<a className="button button-primary button-large" href="/">
								Learn more →
							</a>
						</div>
					</div>
				</section>
			</main>
		</Layout>
	);
};
